// E2E 전용 mock — VITE_E2E_MOCK=true 빌드에서만 동작. prod 빌드엔 tree-shake로 0 영향.
// Playwright가 addInitScript로 window.__SOTDA_E2E__ 에 시나리오 데이터를 주입하면
// apiFetch / useAuth 가 네트워크·인증 없이 그 데이터를 반환한다. (docs/specs/2026-06-19-...)

export const E2E_MOCK = (import.meta.env.VITE_E2E_MOCK as string) === "true";

// 가짜 Supabase 세션 — useAuth 로그인 가드 통과용.
// access_token이 가짜여도 apiFetch가 mock으로 가로채 서버 토큰 검증이 일어나지 않음.
export const E2E_FAKE_SESSION = {
  access_token: "e2e-fake-token",
  refresh_token: "e2e-fake-refresh",
  expires_at: 9999999999,
  expires_in: 3600,
  token_type: "bearer",
  user: {
    id: "e2e-user-0001",
    email: "e2e@sotda.test",
    aud: "authenticated",
    role: "authenticated",
    app_metadata: {},
    user_metadata: { nickname: "E2E시니" },
    created_at: "2026-01-01T00:00:00Z",
  },
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
} as any;

// window.__SOTDA_E2E__ = { routes: { '<path prefix>': <응답 객체> } }
type E2EBag = { routes?: Record<string, unknown> };

/**
 * 시나리오 bag 읽기.
 * - Playwright는 addInitScript로 window에 직접 주입한다(기존 경로).
 * - 크롬으로 실화면을 눈으로 확인할 때는 addInitScript를 쓸 수 없어서,
 *   `_tools/e2e-launcher.html`이 sessionStorage에 넣어둔 값을 대신 읽는다.
 *   (VITE_E2E_MOCK=true 빌드에서만 호출되는 코드라 프로덕션 영향 0 — 2026-07-20)
 */
function readBag(): E2EBag | undefined {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const w = window as any;
  if (w.__SOTDA_E2E__) return w.__SOTDA_E2E__ as E2EBag;
  try {
    const raw = sessionStorage.getItem("__SOTDA_E2E__");
    if (raw) {
      const parsed = JSON.parse(raw) as E2EBag;
      w.__SOTDA_E2E__ = parsed; // 이후 호출은 window에서 바로 읽도록 캐시
      return parsed;
    }
  } catch {
    /* sessionStorage 차단·JSON 파손 시 mock 없음으로 처리 */
  }
  return undefined;
}

/**
 * 요청 path를 시나리오 라우트 테이블과 매칭해 mock 응답을 반환.
 * - 쿼리스트링 제거 후 가장 긴 prefix 매칭 (예: '/api/mobile/sim/debate/abc' → '/api/mobile/sim/debate/')
 * - 매칭 없으면 undefined → 호출부가 undefined면 실네트워크로 폴백하지 않고 빈 응답 처리
 */
export function e2eResolve(path: string): unknown | undefined {
  if (typeof window === "undefined") return undefined;
  const bag = readBag();
  if (!bag?.routes) return undefined;
  const clean = path.split("?")[0];
  let best: string | undefined;
  for (const key of Object.keys(bag.routes)) {
    if (clean === key || clean.startsWith(key)) {
      if (best === undefined || key.length > best.length) best = key;
    }
  }
  return best === undefined ? undefined : bag.routes[best];
}
